import React from 'react';
import { Typography, Button, Avatar } from '@material-ui/core';
import PropTypes from 'prop-types';
import Dropzone from 'sharedComponents/Dropzone';
import { useTranslation } from 'react-i18next';
import useUploadFile from 'reducers/hooks/useUploadFile';

import { isBlank } from 'utils/helperMethods';
import Loader from 'sharedComponents/Loader';
import useStyles from './useStyles';

const CompanyLogo = props => {
  const { label, value, onFinish, isLoading } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const { uploadCompanyLogoToS3, uploadingCompanyLogoImage } = useUploadFile();

  const buildCachedImage = (fields, file) => {
    return {
      id: fields.key.match(/^cache\/(.+)/)[1],
      storage: 'cache',
      metadata: {
        size: file.size,
        filename: file.name,
        mimeType: file.type,
      },
    };
  };

  const handleOnDrop = async file => {
    const currentFile = file[0];
    const params = { type: currentFile.type, filename: currentFile.name };
    const cachedFileFields = await uploadCompanyLogoToS3(params, currentFile);
    const cachedVideo = buildCachedImage(cachedFileFields, currentFile);
    onFinish(cachedVideo);
  };

  const isImageLoading = uploadingCompanyLogoImage || isLoading;

  return (
    <div className={classes.container}>
      <Typography variant="body2" className={classes.label}>
        {label}
      </Typography>
      <div className={classes.content}>
        <div className={classes.logoContainer}>
          {isImageLoading ? (
            <Loader />
          ) : (
            <Avatar alt="company logo" src={value} className={classes.image} variant="square">
              Logo
            </Avatar>
          )}
        </div>
        <Dropzone handleOnDrop={handleOnDrop}>
          <Button variant="outlined" color="primary" className={classes.button}>
            {isBlank(value)
              ? t('components.ProfileForm.buttons.uploadCompanyLogo')
              : t('components.ProfileForm.buttons.changeCompanyLogo')}
          </Button>
        </Dropzone>
      </div>
    </div>
  );
};

CompanyLogo.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onFinish: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

CompanyLogo.defaultProps = {
  value: null,
};

export default CompanyLogo;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/Profile/components/ProfileForm/components/CompanyLogo/CompanyLogo.js